<template>
  <div class="user">
    <div class="common-seach-wrap fr clearfix">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="店铺名称">
          <el-input v-model="formInline.storeName" placeholder="店铺名称" clearable/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="supplierApplyId" label="ID" width="50"></el-table-column>
          <el-table-column prop="" label="商户" min-width="140">
            <template slot-scope="scope">
              <span>{{ scope.row.storeName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="账号名称" min-width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="会员名称" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.nickName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="identity" label="身份" width="100">
            <template slot-scope="scope">
              <span>{{ getApplyIdentityText(scope.row.identity) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkName" label="联系人" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.linkName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="联系方式" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.mobile }}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="address" label="店铺地址" min-width="100">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span>{{ scope.row.address }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column prop="depositMoney" label="保证金" width="80">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span>{{ scope.row.depositMoney }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="" label="图片" width="80">
            <template slot-scope="scope">
              <img v-img-url="scope.row.logoUrl" alt="" width="50px"/>
            </template>
          </el-table-column>
          <el-table-column prop="tradeNo" label="支付单号" min-width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.tradeNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="transactionId" label=" " min-width="230">
            <template slot-scope="scope">
              <span>{{ scope.row.transactionId }}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="payStatus" label="状态" width="80">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span v-if="scope.row.status==0">待审核</span>-->
          <!--              <span v-if="scope.row.status==1">已通过</span>-->
          <!--              <span v-if="scope.row.status==2">未通过</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="createTime" label="申请时间" width="160"></el-table-column>
          <!--          <el-table-column prop="updateTime" label="编辑时间" width="150"></el-table-column>-->
          <!--          <el-table-column fixed="right" label="操作" width="100">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button @click="Audite(scope.row,1)" type="text" size="small" v-if="scope.row.status==0">同意-->
          <!--              </el-button>-->
          <!--              <el-button @click="Audite(scope.row,2)" type="text" size="small" v-if="scope.row.status==0">拒绝-->
          <!--              </el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js'

export default {
  name: 'index',
  data () {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*提货站点列表数据*/
      storeList: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        status: '',
        storeName: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      identityList: [
        {
          id: 1,
          name: '农资零售'
        },
        {
          id: 2,
          name: '农资批发'
        },
        {
          id: 3,
          name: '技术老师'
        },
        {
          id: 4,
          name: '其他身份'
        },
      ],
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      /*获取列表*/
      this.getTableList()
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.getTableList()
    },


    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },

    /*获取列表*/
    getTableList () {
      let self = this
      let Params = this.formInline
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.payStatus = 10
      SupplierApi.supplierPendList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getTableList()
    },

    /* 强制下架上架*/
    Audite (row, state) {
      let self = this
      let war_ = ''
      if (state == 1) {
        self.$confirm('确认要同意吗?', '提示', {
          type: 'warning'
        })
          .then(() => {
            SupplierApi.supplierAudit({
              supplierApplyId: row.supplierApplyId,
              status: state
            }).then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              self.getTableList()
            })
              .catch(error => {
                self.loading = false
              })
          })
      } else if (state == 2) {
        self.$prompt('请输入拒绝理由', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '输入内容不为空'
        }).then(({value}) => {
          SupplierApi.supplierAudit({
            supplierApplyId: row.supplierApplyId,
            status: state,
            content: value
          }).then(data => {
            self.$message({
              type: 'success',
              message: '操作成功'
            })
            self.getTableList()
          }).catch(() => {
            self.$message({
              type: 'info',
              message: '操作失败'
            })
          })
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '取消输入'
          })
        })
      }
    },
    getApplyIdentityText (identity) {
      let text = ''
      if (identity) {
        let item = this.identityList.find(e => {
          return parseInt(e.id) === parseInt(identity)
        })
        if (item) {
          text = item.name || ''
        }
      }

      return text
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/supplier/apply/consult.vue